import React from "react";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import PrimaryButton from "../../../../Forms/PrimaryButton";

const prevNextCss = (prev, next) => css`
    display: flex;
    justify-content: ${prev ? 'flex-start' : next ? 'flex-end' : 'space-between'};
    width: 80%;
    max-width: 900px;
    margin-top: 50px;
`;

const NavButtonsGroup = ({ 
    showPrev, showNext, btnText1, btnText2, disabled, nextClick, prevClick
}) => (
    <>
        <div css={prevNextCss(showPrev, showNext)}>
            <PrimaryButton
                onClick={showNext ? nextClick : prevClick}
                text={btnText1} 
            />
        {!showPrev && !showNext && (
            <PrimaryButton
                onClick={nextClick}
                text={btnText2}
                disabled={disabled}
            />
        )}
        </div>
    </>
);

export default NavButtonsGroup;